// UI Constants
export const UI_CONSTANTS = {
  // Time periods
  ACTIVE_THRESHOLD_DAYS: 14,
  PAGINATION_PAGE_SIZE: 50,
  
  // Colors
  COLORS: {
    slate: {
      primary: 'bg-slate-600',
      secondary: 'bg-slate-100 dark:bg-slate-800',
      text: 'text-slate-600 dark:text-slate-400',
      border: 'border-slate-200 dark:border-slate-700',
      gradient: 'from-slate-600 to-slate-700 dark:from-slate-700 dark:to-slate-800'
    },
    emerald: {
      primary: 'bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-600',
      secondary: 'bg-emerald-50 dark:bg-emerald-900/30',
      text: 'text-emerald-600 dark:text-emerald-400',
      border: 'border-emerald-200 dark:border-emerald-800',
      badge: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'
    },
    amber: {
      primary: 'bg-amber-600',
      secondary: 'bg-amber-50 dark:bg-amber-900/30',
      text: 'text-amber-600 dark:text-amber-400',
      border: 'border-amber-200 dark:border-amber-800',
      badge: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
    },
    red: {
      background: 'bg-red-50 dark:bg-red-900/20',
      border: 'border-red-200 dark:border-red-800',
      text: 'text-red-700 dark:text-red-300',
      title: 'text-red-800 dark:text-red-200',
      button: 'bg-red-600 hover:bg-red-700'
    }
  },
  
  // Animations
  ANIMATIONS: {
    transition: 'transition-all',
    spin: 'animate-spin rounded-full border border-white border-b-transparent'
  }
} as const;

export const DEFAULT_DAILY_ALERT_THRESHOLD_USD = 9.5;

// Date range types
export type DateRange =
  | '1hour'
  | '3hours'
  | '6hours'
  | '1day'
  | 'yesterday'
  | '7days'
  | '30days'
  | '60days'
  | '90days'
  | '120days'
  | '150days'
  | '180days'
  | '360days';
export const PRESET_DATE_RANGES: DateRange[] = [
  '1hour',
  '3hours',
  '6hours',
  '1day',
  'yesterday',
  '7days',
  '30days',
  '60days',
  '90days',
  '120days',
  '150days',
  '180days',
  '360days'
];

// Badge types
export type BadgeVariant = 'emerald' | 'amber' | 'slate' | 'red';

// Status types
export type Status = 'Active' | 'Inactive';
export type ProjectStatus = 'active' | 'inactive';
export type UserRole = 'owner' | 'reader' | 'member';
